export const journeyTypes = {
  JOURNEY: 'JOURNEY',
  JOURNEY_TEMPLATE: 'JOURNEY_TEMPLATE',
  RELAY: 'RELAY',
};